<wl-experience-editor>
  <ng-template wlLive>
    @if (shouldShow) {
      <wl-information-block
        [rendering]="rendering"
        [title]="rendering?.fields?.title"
        [message]="rendering?.fields?.body"
        [link]="rendering?.fields?.link"
        [linedTitle]="linedTitle"
        [sideNote]="sideNote"
        [icon]="rendering?.fields?.icon | scIcon"
      >
        @if (showCustomerCooldown) {
          <div class="mt-2" wlAutomationId="mijn-information-block-cooldown">
            <div class="d-flex bg-light p-2">
              <fa-icon size="lg" icon="circle-info"></fa-icon>
              <wl-rich-text-wrapper
                class="ps-2"
                [field]="rendering?.fields?.OnboardingMessage"
                [rendering]="rendering"
              >
                <div></div>
              </wl-rich-text-wrapper>
            </div>
          </div>
        }
      </wl-information-block>
    }
  </ng-template>
  <ng-template wlPreview>
    <div class="card shadow-sm mb-3">
      <div class="card-body">
        <div class="d-flex align-items-baseline">
          @if (rendering?.fields?.icon?.value) {
            <fa-icon
              [icon]="rendering?.fields?.icon | scIcon"
              class="me-1"
            ></fa-icon>
          }
          <h3
            class="card-title h5"
            [ngClass]="linedTitle ? 'mb-0' : 'mb-1'"
            *scText="rendering?.fields?.title"
          ></h3>
        </div>
        @if (linedTitle) {
          <hr />
        }

        <wl-rich-text-wrapper
          [field]="rendering?.fields?.body"
          [rendering]="rendering"
        >
          <p class="mb-1" [ngClass]="{ 'text-body-secondary': sideNote }"></p>
        </wl-rich-text-wrapper>

        <a class="card-link" *wlGenericLink="rendering?.fields?.link"></a>
        <div class="mt-2">
          <div class="d-flex bg-light p-2">
            <fa-icon size="lg" icon="circle-info"></fa-icon>
            <wl-rich-text-wrapper
              class="ps-2"
              [field]="rendering?.fields?.OnboardingMessage"
              [rendering]="rendering"
            >
              <div></div>
            </wl-rich-text-wrapper>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</wl-experience-editor>
